import { useQuery } from "@apollo/client";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { getDateRace } from "@urp/store-selectors";
import queryHelper from "../graphql/options.graph";
import { GetAllWagerTypesQueryProps, WagerTypesGraphResponse } from "../types";
import { GET_ALL_WAGER_TYPES } from "../graphql/queries/AllWagerTypes";

const useGetAllWagerTypes = ({
  wagerProfile,
  queryBets
}: GetAllWagerTypesQueryProps) => {
  const raceDate = useSelector(getDateRace);

  const {
    data,
    loading: isLoadingGraph,
    subscribeToMore: subscribeToMoreGraph
  } = useQuery<WagerTypesGraphResponse>(
    GET_ALL_WAGER_TYPES,
    queryHelper.apolloOptions({ wagerProfile, queryBets, raceDate })
  );

  return {
    races: get(data, "races", []),
    currentRaceDate: get(data, "raceDate", ""),
    hasGraphData: !!data,
    isLoadingGraph,
    subscribeToMoreGraph
  };
};

export default useGetAllWagerTypes;
